var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"export-content-body"},[_c('div',{staticClass:"export-completed"},[_c('i',{staticClass:"fa-regular fa-party-horn icon"}),_c('p',{staticClass:"export-completed-title"},[_vm._v(_vm._s(_vm.$t('export.label.emailSend')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }